var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useMediaQuery, useTheme as useMuiTheme } from '@material-ui/core';
import { mdiHeart, mdiHeartOutline, mdiThumbUp, mdiThumbUpOutline, mdiCalendarClock, mdiBookshelf } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../../../../lib';
import { TooltippedIconButton } from '../../../../../Buttons';
import { MoreSkillActionsMenu } from '../../../../../Menus/MoreSkillActionsMenu';
import { ShareMenu } from '../../../../../Menus/ShareMenu';
import ViewerErrorBoundary from '../../ViewerConclusion/ViewerErrorBoundary';
const VerticalDivider = styled.div `
    border-right: 1px solid ${(props) => props.theme.colors.border};
    height: 24px;
    margin: 0 8px;
`;
const Stats = styled.p `
    margin-right: 8px;
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
`;
const ActionsWrapper = styled.div `
    display: flex;
    align-items: center;
`;
export const SkillActionButtons = (_a) => {
    var { likes, liked, favorited, onThumbsUp, onFavorite, onAddToSchedule, onAddToBookshelf, onChangeLearningMode, mode, disabledModes, onEdit, onResetProgress } = _a, shareMenuProps = __rest(_a, ["likes", "liked", "favorited", "onThumbsUp", "onFavorite", "onAddToSchedule", "onAddToBookshelf", "onChangeLearningMode", "mode", "disabledModes", "onEdit", "onResetProgress"]);
    const muiTheme = useMuiTheme();
    const shouldRender = useMediaQuery(muiTheme.breakpoints.up('sm'));
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(ActionsWrapper, null,
            React.createElement(TooltippedIconButton, { icon: React.createElement(Icon, { size: IconSize.Medium, path: liked ? mdiThumbUp : mdiThumbUpOutline }), title: liked ? 'Unlike' : 'Like', disabled: !onThumbsUp, onClick: onThumbsUp, "aria-label": "Thumbs Up" }),
            React.createElement(Stats, null, likes !== null && likes !== void 0 ? likes : 0),
            React.createElement(VerticalDivider, null),
            React.createElement(TooltippedIconButton, { icon: React.createElement(Icon, { size: IconSize.Medium, path: mdiCalendarClock }), title: "Learn later", disabled: !onAddToSchedule, onClick: onAddToSchedule, "aria-label": "Add to schedule" }),
            shouldRender ? (React.createElement(React.Fragment, null,
                React.createElement(TooltippedIconButton, { icon: React.createElement(Icon, { size: IconSize.Medium, path: mdiBookshelf }), title: "Add to bookshelf", disabled: !onAddToBookshelf, onClick: onAddToBookshelf, "aria-label": "Add to bookshelf" }),
                React.createElement(TooltippedIconButton, { icon: React.createElement(Icon, { size: IconSize.Medium, path: favorited ? mdiHeart : mdiHeartOutline }), title: `${favorited ? 'Remove from' : 'Add to'} favorites`, disabled: !onFavorite, onClick: onFavorite, "aria-label": "Favorite" }),
                React.createElement(ShareMenu, Object.assign({ variant: "button" }, shareMenuProps)))) : null,
            React.createElement(MoreSkillActionsMenu, { onAddToSchedule: onAddToSchedule, onChangeLearningMode: onChangeLearningMode, mode: mode, disabledModes: disabledModes, onEdit: onEdit, onResetProgress: onResetProgress, onAddToBookshelf: onAddToBookshelf, onFavorite: onFavorite, favorited: favorited }))));
};
//# sourceMappingURL=SkillActionButtons.js.map